import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const UploadIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M11.2 4.4a6 6 0 0 0-6.5 9.8 1 1 0 0 1-1.4 1.4A8 8 0 1 1 16.4 7h1.1a5.5 5.5 0 0 1 3 10 1 1 0 0 1-1-1.6 3.5 3.5 0 0 0-2-6.4h-1.8a1 1 0 0 1-1-.7 6 6 0 0 0-3.5-3.9Z" />
    <path d="m13 14.4 2.3 2.3a1 1 0 0 0 1.4-1.4l-4-4a1 1 0 0 0-1.4 0l-4 4a1 1 0 1 0 1.4 1.4l2.3-2.3V21a1 1 0 1 0 2 0v-6.6Z" />
  </Icon>
));
export default UploadIcon;
